import { exportReport } from 'partner360/services/report/exportReport'

import { TMarketYoyGrowthExpectationRtm } from './types'

const MARKET_YOY_GROWTH_EXPORT_ENTRY_ID = 286

interface IExportMarketYoyGrowthExpectationsParams {
  fYear: number
  rtm: TMarketYoyGrowthExpectationRtm
}

/** Downloads the market YoY growth targets Excel report (all markets) for one FYear + RTM. */
export const exportMarketYoyGrowthExpectations = ({
  fYear,
  rtm,
}: IExportMarketYoyGrowthExpectationsParams) =>
  exportReport({
    filename: `Market YoY Targets_FY${String(fYear).slice(-2)}_${rtm}.xlsx`,
    entryId: MARKET_YOY_GROWTH_EXPORT_ENTRY_ID,
    mappings: { FYear: fYear, RTM: rtm },
  })
